module.exports = __webpack_public_path__ + "39815b389a257e342609b7986f1059af.svg";